import { CmsManagerCtrlApi } from "./generated/api";
import { apiCall, config, getConfig, serverUrl, axiosInstance } from "./Utils";
import { APP_NAME } from "../App";
import type { ApiResult, CmsViewDto } from "../types/api";

const cmsManagerCtrlApi = new CmsManagerCtrlApi(config, serverUrl, axiosInstance);

async function getCmsTemplate(): Promise<ApiResult<CmsViewDto>> {
    return apiCall(cmsManagerCtrlApi.apiCmsIdGet(APP_NAME));
}

async function getTranslations(lng: string): Promise<ApiResult<object>> {
    return apiCall(cmsManagerCtrlApi.apiCmsIdLngTranslationsJsonGet(APP_NAME, lng));
}

async function updateCmsTemplate(viewDto: CmsViewDto): Promise<ApiResult<void>> {
    return apiCall(axiosInstance.post(`${serverUrl}/api/cms/${APP_NAME}`, viewDto, getConfig()));
}

async function uploadImage(file: File): Promise<ApiResult<{ filename: string }>> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("fileName", file.name);
    return apiCall(axiosInstance.post(`${serverUrl}/api/cms/images`, formData, {
        ...getConfig(),
        headers: {
            ...getConfig().headers,
            "Content-Type": "multipart/form-data",
        },
    }));
}

function getImageUrl(filename: string): string {
    return `${serverUrl}/api/cms/images/${filename}`;
}

const ApiCmsCtrl = {
    getCmsTemplate,
    getTranslations,
    updateCmsTemplate,
    uploadImage,
    getImageUrl,
};

export default ApiCmsCtrl;
